import axios from 'axios';
import api from './apiConfig';
import { LoginResponse, RegisterResponse } from '../types/auth';

export const login = async (email: string, password: string): Promise<LoginResponse> => {
  try {
    const response = await api.post<LoginResponse>('/api/auth/login', { email, password });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      throw new Error(error.response.data.error || 'Failed to login');
    }
    throw new Error('Network error when trying to login');
  }
};

export const register = async (
  username: string, 
  email: string, 
  password: string
): Promise<RegisterResponse> => {
  try {
    const response = await api.post<RegisterResponse>('/api/auth/register', {
      username,
      email,
      password
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      throw new Error(error.response.data.error || 'Failed to register');
    }
    throw new Error('Network error when trying to register');
  }
};

export const getCurrentUser = async () => {
  try {
    const response = await api.get('/api/auth/me');
    return response.data;
  } catch (error) {
    throw new Error('Not authenticated');
  }
};

export const forgotPassword = async (email: string): Promise<{ message: string }> => {
  try {
    const response = await api.post<{ message: string }>('/api/auth/forgot-password', { email });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      throw new Error(error.response.data.error || 'Failed to process forgot password request');
    }
    throw new Error('Network error when submitting forgot password request');
  }
};

export const resetPassword = async (token: string, password: string): Promise<{ message: string }> => {
  try {
    const response = await api.post<{ message: string }>(`/api/auth/reset-password/${token}`, { password });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      throw new Error(error.response.data.error || 'Failed to reset password');
    }
    throw new Error('Network error when trying to reset password');
  }
};